import { useState } from 'react';
import { path, prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { setConfigurationAction } from 'js/components/system/App/store/actions';

import * as server from './server';
import * as helpers from './helpers';
import * as constants from './constants';

export const useResponsibleGaming = (portletType) => {
    const type = constants.PORTLET_TYPES_TO_APP_TYPES_MAP[portletType];
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const [isFetchingConfig, setIsFetchingConfig] = useState(false);
    const limitsConfig = useAppSelector(path(['rgConfig', type]));
    const cmsConfig = useAppSelector(prop(type));
    const dispatch = useDispatch();

    useMountEffect((isMounted) => {
        // todo - will never happen :(
        // on the other hand, how often limit's config is changed in IMS?
        if (!isLoggedIn) {
            dispatch(setConfigurationAction());

            return;
        }

        if (limitsConfig) {
            return;
        }

        setIsFetchingConfig(true);

        server.fetchConfiguration()
            .then(({ data }) => {
                isMounted() && dispatch(setConfigurationAction(helpers.parseConfiguration(data)));
            })
            .catch(console.error)
            .finally(() => isMounted() && setIsFetchingConfig(false));
    }, [isLoggedIn, limitsConfig, dispatch]);

    return [isFetchingConfig, limitsConfig, cmsConfig];
};
